// Accepts Prisma Decimal (via toString), number, string, null, undefined
type PriceInput = number | string | { toString(): string } | null | undefined

// Ręczny formatter: pl-PL z NBSP jako separator tysięcy + przecinek dziesiętny + "zł" na końcu.
// Node Intl pl-PL na niektórych platformach nie grupuje tysięcy (np. "2399,00 zł" zamiast "2 399,00 zł").
export function formatPrice(price: PriceInput): string {
  const raw = Number(price ?? 0)
  // Guard: NaN/Infinity (np. uszkodzony wpis koszyka) → 0 zamiast "NaN,undefined zł".
  const n = Number.isFinite(raw) ? raw : 0
  const fixed = n.toFixed(2)
  const [intPart, fracPart] = fixed.split('.')
  const grouped = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
  return `${grouped},${fracPart} zł`
}

// Polski plural: 1 → one, 2-4 (poza 12-14) → few, reszta → many
// pluralPl(1,  ['produkt','produkty','produktów']) === 'produkt'
// pluralPl(3,  [...]) === 'produkty'
// pluralPl(13, [...]) === 'produktów'   ← wyjątek 12-14
// pluralPl(22, [...]) === 'produkty'
export function pluralPl(n: number, [one, few, many]: readonly [string, string, string]): string {
  if (n === 1) return one
  const lastDigit = n % 10
  const lastTwo = n % 100
  if (lastDigit >= 2 && lastDigit <= 4 && (lastTwo < 12 || lastTwo > 14)) return few
  return many
}
